export default __webpack_public_path__ + "static/media/staking-coins.30460a3d.svg";